import { ApiSaveClaimCoverageResponseInterface, SaveClaimCoverageResponseInterface } from '../interfaces';

export function mapSaveClaimCoverageResponse(
    response: ApiSaveClaimCoverageResponseInterface
): SaveClaimCoverageResponseInterface {
    return response;
}
